import { useEffect, useState } from 'react';
import { getRuleProgress } from '../api';

const POLL_MS = 5000;

export const ruleKey = (builderName, timestamp) => `${builderName}|${timestamp}`;

// Polls the server for rule sets that are compiling or scoring. Returns a map from
// ruleKey(builder_name, timestamp) to {stage, done, total, detail}. Because it comes from the
// server, it survives a page reload (unlike state set from websocket messages).
export default function useRuleProgress() {
    const [running, setRunning] = useState({});

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const list = await getRuleProgress();
                if (cancelled) return;
                setRunning(Object.fromEntries(list.map((item) => [ruleKey(item.builder_name, item.timestamp), item])));
            } catch (error) {
                console.error('Could not load rule progress:', error);
            }
        };
        load();
        const timer = setInterval(load, POLL_MS);
        return () => {
            cancelled = true;
            clearInterval(timer);
        };
    }, []);

    return running;
}
